export const MESSAGES = {
  INVALID_EMAIL_PASSWORD: 'Either email or password is invalid or your account is inactive.',
  SOME_ERROR: 'Opps! Something went wrong. Please try again later.',
  LOGIN_SUCCESS: 'You are successfully logged in.',
  LOGOUT_SUCCESS: 'You are successfully logged out.',
  UPDATE_PASSWORD_SUCCESS: 'Your password has been successfully updated.',
  NOT_VERIFIED_USER: 'Your account is pending for verification. Please verify your account for login.',

  //MASTERS
  PART_ADD_SUCCESS: 'Part added successfully.',
  PART_DELETE_SUCCESS: 'Part has been deleted.',
  UPDATE_PART_SUCESS: 'Part updated successfully',
  MESSAGE_SENT_EXCEPT_USER: 'Message has been sent except the user',
  UOM_ADD_SUCCESS: 'Unit Of measurement added successfully',
  UPDATE_UOM_SUCESS: 'Unit Of measurement updated successfully',
  DELETE_UOM_SUCCESS: 'Unit Of measurement deleted successfully',
  CONFIRM_DELETE: 'Are you sure you want to delete This',

  PLANT_ADDED_SUCCESS: 'Plant created successfully',
  SUPPLIER_ADDED_SUCCESS: 'Supplier added successfully',

  BOM_ADD_SUCCESS: 'Bill of material added successfully',
  BOM_DELETE_ALERT: 'Are you sure you want to delete Assembly Part?',
  DELETE_BOM_SUCCESS: 'Assembly Part deleted successfully',
  UPDATE_BOM_SUCCESS: 'Assembly Part updated successfully',

  //CATEGORY MASTER
  CATEGORY_TYPE_ADDED_SUCCESS: 'Category type added successfully',
  CATEGORY_TYPE_UPDATE_SUCCESS: 'Category type has been updated successfully.',
  CATEGORY_TYPE_DELETE_ALERT: 'Are you sure you want to delete Category type?',
  DELETE_CATEGORY_TYPE_SUCCESS: 'Category type has been deleted successfully.',
  CATEGORY_UPDATE_SUCCESS: 'Category has been updated successfully.',
  CATEGORY_DELETE_ALERT: 'Are you sure you want to delete Category?',
  DELETE_CATEGORY_SUCCESS: 'Category has been deleted successfully.',

  //CATEGORY (RAW MATERIAL)
  CATEGORY_ADD_SUCCESS: 'Category created successfully',
  CATEGORY_DELETE_ALERT: 'Are you sure you want to delete Category?',
  DELETE_CATEGORY_SUCCESS: 'Category has been deleted successfully.',

  //OTHER OPERATION
  OTHER_OPERATION_ADD_SUCCESS: 'Other Operation added successfully',
  OTHER_OPERATION_DELETE_ALERT: 'Are you sure you want to delete Other Operation?',
  DELETE_OTHER_OPERATION_SUCCESS: 'Other Operation has been deleted successfully.',

  //CED OTHER OPERATION
  CED_OTHER_OPERATION_ADD_SUCCESS: 'CED Other Operation added successfully',
  CED_OTHER_OPERATION_DELETE_ALERT: 'Are you sure you want to delete CED Other Operation?',
  DELETE_CED_OTHER_OPERATION_SUCCESS: 'CED Other Operation has been deleted successfully.',
  CED_OTHER_OPERATION_UPDATE_SUCCESS: 'CED Other Operation has been updated successfully.',

  //OPERATION
  OPERATION_ADD_SUCCESS: 'Operation added successfully',
  OPERATION_UPDATE_SUCCESS: 'Operation has been updated successfully',
  OPERATION_DELETE_ALERT: 'Are you sure you want to delete Operation?',
  DELETE_OPERATION_SUCCESS: 'Operation has been deleted successfully.',

  //RAW MATERIAL
  MATERIAL_ADD_SUCCESS: 'Row material details added successfully.',
  MATERIAL_TYPE_DELETE_ALERT: 'Are you sure you want to delete Material Type?',
  DELETE_MATERIAL_TYPE_SUCCESS: 'Material Type has been deleted successfully.',
  RAW_MATERIAL_DETAIL_DELETE_ALERT: 'Are you sure you want to delete Raw Material detail?',
  DELETE_RAW_MATERIAL_SUCCESS: 'Raw Material detail has been deleted successfully.',
  RAW_MATERIAL_DETAILS_UPDATE_SUCCESS: 'Raw Material Details has been updated successfully',

  //RM GRADE
  GRADE_ADD_SUCCESS: 'Raw Material Grade added successfully',
  RM_GRADE_DELETE_ALERT: 'Are you sure you want to delete Grade?',
  RM_GRADE_UPDATE_SUCCESS: 'Raw Material Grade has been updated successfully',
  DELETE_RM_GRADE_SUCCESS: 'Grade has been deleted successfully.',

  //RM SPECIFICATION
  SPECIFICATION_ADD_SUCCESS: 'Row material specification added successfully',
  SPECIFICATION_DELETE_ALERT: 'Are you sure you want to delete RM Specification?',
  DELETE_SPECIFICATION_SUCCESS: 'RM Specification has been deleted successfully.',
  SPECIFICATION_UPDATE_SUCCESS: 'RM Specification has been updated successfully',

  //RAW MATERIAL
  MATERIAL_ADDED_SUCCESS: 'Raw Material added successfully',
  MATERIAL_DELETE_ALERT: 'Are you sure you want to delete Raw Material?',
  DELETE_MATERIAL_SUCCESS: 'Raw Material has been deleted successfully.',
  MATERIAL_UPDATE_SUCCESS: 'Raw Material has been updated successfully',

  FREIGHT_ADDED_SUCCESS: 'Freight added successfully',
  LABOUR_ADDED_SUCCESS: 'Labour added successfully',

  //OVERHEAD AND PROFIT
  OVERHEAD_PROFIT_ADDED_SUCCESS: 'Overhead profit added successfully',
  OVERHEAD_PROFIT_DELETE_ALERT: 'Are you sure you want to delete Overhead & Profit?',
  DELETE_OVERHEAD_PROFIT_SUCCESS: 'Overhead & Profit deleted successfully',
  OVERHEAD_PROFIT_UPDATE_SUCCESS: 'Overhead & Profit has been updated successfully',

  //DEPRECIATION 
  DEPRECIATION_ADD_SUCCESS: 'Depreciation added successfully',
  DEPRECIATION_DELETE_ALERT: 'Are you sure you want to delete Depreciation?',
  DEPRECIATION_DELETE_SUCCESS: 'Depreciation deleted successfully',
  DEPRECIATION_UPDATE_SUCCESS: 'Depreciation has been updated successfully',

  DELETE_FUEL_DETAIL_SUCCESS: 'Fuel detail deleted successfully',
  DELETE_FUEL_TYPE_SUCCESS: 'Fuel type deleted successfully',
  DELETE_PLANT_SUCCESS: 'Plant deleted successfully',
  UPDATE_PLANT_SUCESS: 'Plant updated successfully',
  DELETE_PROCESS_SUCCESS: 'Process deleted successfully',
  UPDATE_PROCESS_SUCCESS: 'Process updated successfully',
  PROCESS_ADD_SUCCESS: 'Process added successfully',
  DELETE_BOP_SUCCESS: 'Bought out part deleted successfully',
  DELETE_FREIGHT_SUCCESS: 'Freight deleted successfully',
  UPDATE_FREIGHT_SUCESS: 'Freight updated successfully',
  DELETE_LABOUR_SUCCESS: 'Labour deleted successfully',
  UPDATE_LABOUR_SUCCESS: 'Labour updated successfully',
  DELETE_SUPPLIER_SUCCESS: 'Supplier deleted successfully',
  UPDATE_SUPPLIER_SUCESS: 'Supplier updated successfully',
  UPDATE_BOP_SUCESS: 'BOP updated successfully',
  FUEL_DETAIL_ADD_SUCCESS: 'Fuel detail added successfully',
  FUEL_ADD_SUCCESS: 'Fuel added successfully',
  FUEL_DELETE_ALERT: 'Are you sure you want to delete Fule?',
  FUEL_DETAIL_DELETE_ALERT: 'Are you sure you want to delete Fule Detail?',
  ADD_BOP_SUCCESS: 'BOP added successfully',
  BOP_ADD_SUCCESS: 'BOP added successfully',
  INTEREST_RATE_ADDED_SUCCESS: 'Suppiler interest rate added successfully',
  DELETE_INTEREST_RATE_SUCCESS: 'Supplier interest rate deleted successfully',
  UPDATE_INTEREST_RATE_SUCESS: 'Supplier interest rate updated successfully',
  ADD_PART_WITH_SUPPLIER_SUCCESS: 'Supplier has been added successfully.',
  NEW_COSTING_CREATE_SUCCESS: 'New sheetmetal costing created successfully',
  BOM_DELETE_SUCCESS: 'BOM has been deleted.',
  WEIGHT_ADD_SUCCESS: 'Weight specification added successfully',
  SAVE_OTHER_OPERATION_SUCCESS: 'Other Operation saved successfully.',
  SAVE_PROCESS_COSTING_SUCCESS: 'Process costing saved successfully.',
  SAVE_BOP_COSTING_SUCCESS: 'Bought Out Part costing saved successfully.',
  UPDATE_COSTING_OTHER_OPERATION_SUCCESS: 'Other Operation has been updated.',
  COSTING_HAS_BEEN_DRAFTED_SUCCESSFULLY: 'Costing has been drafted successfully.',
  SELECT_PART_FOR_ZBC_COSTING: 'Please select part for zbc costing.',
  CANCEL_COSTING_ALERT: 'Are you sure you want to cancel costing?',

  //MACHINE MASTER
  DELETE_MACHINE_SUCCESS: 'Machine has been deleted successfully.',
  DELETE_MACHINE_TYPE_SUCCESS: 'Machine Type has been deleted successfully.',
  MACHINE_DELETE_ALERT: 'Are you sure you want to delete Machine?',
  MACHINE_TYPE_DELETE_ALERT: 'Are you sure you want to delete Machine Type?',

  //MACHINE TYPE
  MACHINE_TYPE_ADD_SUCCESS: 'Machine Class has been added successfully.',
  UPDATE_MACHINE_TYPE_SUCESS: 'Machine Class has been updated successfully.',
  MACHINE_ADD_SUCCESS: 'Machine has been added successfully.',

  //POWER MASTER
  POWER_DELETE_ALERT: 'Are you sure you want to delete Power?',
  POWER_DELETE_SUCCESS: 'Power has been deleted successfully.',
  POWER_ADDED_SUCCESS: 'Power added successfully',
  UPDATE_POWER_SUCESS: 'Power has been updated successfully.',

  //REASON MASTER
  REASON_ADD_SUCCESS: 'Reason has been added successfully.',
  UPDATE_REASON_SUCESS: 'Reason has been updated successfully.',

  //USER
  ADD_USER_SUCCESSFULLY: 'User has been added successfully.',
  DELETE_USER_SUCCESSFULLY: 'User has been deleted successfully.',
  USER_ACTIVE_SUCCESSFULLY: 'User has been active successfully.',
  USER_INACTIVE_SUCCESSFULLY: 'User has been inactive successfully.',
  USER_DELETE_ALERT: 'Are you sure you want to delete User?',
  UPDATE_USER_SUCCESSFULLY: 'User has been updated successfully.',
  COSTING_DELETE_ALERT: 'All Costing which are pending for approval and whose approval are awaited will get rejected. Do you wish to proceed further?',

  //ROLE
  ADD_ROLE_SUCCESSFULLY: 'Role has been added successfully.',
  UPDATE_ROLE_SUCCESSFULLY: 'Role has been updated successfully.',
  DELETE_ROLE_SUCCESSFULLY: 'Role has been deleted successfully.',
  ROLE_DELETE_ALERT: 'Are you sure you want to delete Role?',

  //DEPARTMENT
  ADD_DEPARTMENT_SUCCESSFULLY: 'Department has been added successfully.',
  UPDATE_DEPARTMENT_SUCCESSFULLY: 'Department has been updated successfully.',
  DELETE_DEPARTMENT_SUCCESSFULLY: 'Department has been deleted successfully.',
  DEPARTMENT_DELETE_ALERT: 'Are you sure you want to delete Department?',

  //LEVEL
  ADD_LEVEL_SUCCESSFULLY: 'User level has been added successfully.',
  UPDATE_LEVEL_SUCCESSFULLY: 'Level has been updated successfully.',
  DELETE_LEVEL_SUCCESSFULLY: 'Level has been deleted successfully.',
  LEVEL_DELETE_ALERT: 'Are you sure you want to delete Level?',
  ADD_LEVEL_USER_SUCCESSFULLY: 'Level of users has been added successfully.',

  //LEVEL FOR TECHNOLOGY
  ADD_LEVEL_TECHNOLOGY_USER_SUCCESSFULLY: 'Level of technology added successfully.',
  UPDATE_LEVEL_TECHNOLOGY_USER_SUCCESSFULLY: 'Level of technology updated successfully.',

  //ADDITIONAL FREIGHT
  ADDITIONAL_FREIGHT_ADD_SUCCESS: 'Packaging has been added successfully.',
  DELETE_ADDITIONAL_FREIGHT_SUCCESS: 'Additional Freight has been deleted successfully.',
  WEIGHT_SPEC_UPDATE_SUCCESS: 'Weight specification updated successfully.',
  WEIGHT_SPEC_ADDED_SUCCESS: 'Weight specification added successfully',
  SELECT_SUPPLIER_BEFORE_ADD_VALUE: 'Please add supplier before adding value.',
  SOB_LESS_THAN_100: 'SOB Sould be less than 100%.',
  SOB_GREATER_THAN_ZERO: 'SOB Sould be greater than 0.',
  COSTING_SAVED_SUCCESSFULLY: 'Costing has been saved successfully.',
  COSTING_SENT_FOR_APPROVAL_SUCCESSFULLY: 'Costing has been sent for approval.',
  SELECT_PLANT_FOR_COSTING: 'Plant should not be empty.',
  REASSIGN_COSTING_SUCCESS_MESSAGE: 'Costing has been reassign successfully.',
  COSTING_CANCEL_SUCCESS_MESSAGE: 'Costing has been cancel successfully.',

  //PRIVILEGE
  ADD_PRIVILEGE_PAGE_SUCCESSFULLY: 'Privilege page added successfully.',
  ADD_PRIVILEGE_PAGE_ROLEWISE_SUCCESSFULLY: 'Privilege page role wise added successfully.',
  ADD_PRIVILEGE_PAGE_USERWISE_SUCCESSFULLY: 'Privilege page user wise added successfully.',
  ADDITIONAL_PERMISSION_ADDED_SUCCESSFULLY: 'Additional permission has been added successfully.',

  //REASON
  REASON_DELETE_ALERT: 'Are you sure you want to delete Reason?',

  //MHR
  MHR_DELETE_ALERT: 'Are you sure you want to delete Machine Rate?',
  DELETE_MHR_SUCCESS: 'Machine Rate has been deleted successfully.',
  MHR_MASTER_ADD_SUCCESS: 'MHR Master added successfully',
  UPDATE_MHR_SUCCESSFULLY: 'Machine Rate has been updated successfully.',

  //COPY COSTING
  COPY_COSTING_SUCCESS: 'Costing successfully copied.',

  //DEPARATMENT EMPTY
  DEPARTMENT_EMPTY_ALERT: 'Permission should not be empty.',

  //SHUTTER DESIGN
  SHUTTER_DESIGN_DELETE_ALERT: 'Are you sure you want to delete Shutter Design?',
  CREATE_COPY_ALERT: 'Do you want to create copy of existing Shutter Design?',


  //Users Active Deactive
  USERACTIVATE: 'Do you want to continue ?',


};

